export interface ListingPathTarget {
  id: number;
  slug?: string | null;
}

const LISTING_ID_PATTERN = /^\d+$/;

// Slugs are never all digits, so an all-digit route ref is always a legacy id.
export const isListingId = (listingRef: string): boolean => LISTING_ID_PATTERN.test(listingRef);

export const propertyPath = (listing: ListingPathTarget): string =>
  `/property/${listing.slug || listing.id}`;

export const servicePath = (listing: ListingPathTarget): string =>
  `/service/${listing.slug || listing.id}`;
